import React from 'react'

import { Http, IubendaRequests } from 'lib'
import IUserData from 'types/sign-in/IUserData'

import { TermsAcceptanceState } from './store/State'
import { setIsLoadingData, setTermsAndConditions, setPrivacyPolicy, TermsAcceptanceAction } from './store/Actions'
import { IAcceptTermsPayload, IRejectTermsPayload } from './Interfaces'
import apiUrlsAddresses from '../../config/constants/api-urls-addresses'

export default class TermsAcceptanceService {
  static async loadTermsAndConditions(state: TermsAcceptanceState, dispatch: React.Dispatch<TermsAcceptanceAction>) {
    if (!state.isLoadingData) {
      dispatch(setIsLoadingData(true))
      const termsAndConditions = await IubendaRequests.requestTermsAndConditions()
      dispatch(setTermsAndConditions(termsAndConditions))
      dispatch(setIsLoadingData(false))
    }
  }

  static async loadPrivacyPolicy(state: TermsAcceptanceState, dispatch: React.Dispatch<TermsAcceptanceAction>) {
    if (!state.isLoadingData) {
      dispatch(setIsLoadingData(true))
      const privacyAndPolicy = await IubendaRequests.requestPrivacyPolice()
      dispatch(setPrivacyPolicy(privacyAndPolicy))
      dispatch(setIsLoadingData(false))
    }
  }

  static acceptTerms(
    state: TermsAcceptanceState,
    dispatch: React.Dispatch<TermsAcceptanceAction>,
    onSuccess: (user: IUserData) => void,
    onError: (error: string) => void
  ) {
    return async () => {
      dispatch(setIsLoadingData(true))

      const [data, , error] = await Http.post<IAcceptTermsPayload, { user: IUserData }>(
        apiUrlsAddresses.me.acceptTermsOfService(),
        {
          termsOfServiceText: state.termsAndConditions,
          privacyPolicyText: state.privacyPolicy
        }
      )

      dispatch(setIsLoadingData(false))

      if (error) {
        onError(error)
        return
      }

      onSuccess(data.user)
    }
  }

  static rejectTerms(
    _state: TermsAcceptanceState,
    dispatch: React.Dispatch<TermsAcceptanceAction>,
    onSuccess: () => void,
    onError: (error: string) => void
  ) {
    return async (password: string) => {
      dispatch(setIsLoadingData(true))

      const [, , error] = await Http.post<IRejectTermsPayload, {}>(apiUrlsAddresses.me.deleteAccount(), { password })

      dispatch(setIsLoadingData(false))

      if (error) {
        onError(error)
        return
      }

      onSuccess()
    }
  }
}
